import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Row, Typography } from 'antd';
import clsx from 'clsx';
import styles from './style.module.less';
const { Text } = Typography;
const TutorialTooltip = ({ children, stepCount, stepIndex }) => (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.header, children: _jsx("div", { className: styles.headerSteps, children: new Array(stepCount).fill(null).map((_, index) => (_jsx(Row
                // We KNOW what we are doing!
                // eslint-disable-next-line react/no-array-index-key
                , { className: clsx(styles.step, { [styles.stepActive]: stepIndex === index }) }, index))) }) }), _jsx(Text, { strong: true, children: children })] }));
export default TutorialTooltip;
